module.exports = __webpack_public_path__ + "static/media/wheel-works.a5493d26.svg";